<script lang="ts">
	import AdaptiveImage from '../components/AdaptiveImage.svelte';
	import ButtonBoxPrimary from '../elements/buttons/variants/ButtonBoxPrimary.svelte';
	import type { ImageModel } from '@app/models/api/ImageModel';
	import { TypeVideoEmbedEnum } from '@app/models/api/enums/TypeVideoEmbedEnum';
	import AdaptiveVideo from './AdaptiveVideo.svelte';
	import { getEmbedVideoUrl } from '@app/utils/videos';

	export let photosUrls: ImageModel[];
	export let typeVideoEmbed: TypeVideoEmbedEnum = null;
	export let idVideoEmbed: string = null;

	let selected = 0;

	if (idVideoEmbed && typeVideoEmbed) {
		let videoEquipe: ImageModel = {
			title: '',
			url: getEmbedVideoUrl(idVideoEmbed, typeVideoEmbed)
		};
		photosUrls = [videoEquipe].concat(photosUrls);
	}

	/**
	 * About <${'style'}> tags -> issue with prettier -> (https://github.com/sveltejs/prettier-plugin-svelte/issues/59#issuecomment-643336817)
	 */
</script>

<div>
	{#each photosUrls as item, index}
		{@html `<${'style'}>.carousel__activator:nth-of-type(${
			index + 1
		}):checked ~ .carousel__controls:nth-of-type(${index + 1}) { display: flex; }</${'style'}>`}
		{@html `<${'style'}>.carousel__activator:nth-of-type(${
			index + 1
		}):checked ~ .carousel__screen .carousel__track { transform: translateX(${
			index * -100
		}%); }</${'style'}>`}
	{/each}
	<div class="carousel">
		{#each photosUrls as item, index}
			<input
				id="carousel-activator-{index}"
				class="carousel__activator"
				type="radio"
				name="activator"
				value={index}
				bind:group={selected}
			/>
		{/each}

		{#each photosUrls as item, index}
			<div class="carousel__controls">
				<label
					class="carousel__control carousel__control--backward mr-1 z-1 cursor-pointer"
					for="carousel-activator-{index - 1}"
					class:cursor-not-allowed={index === 0}
				>
					<ButtonBoxPrimary
						props={{
							iconLeft: 'arrow_left',
							size: 'small',
							classNames: 'pointer-events-none',
							roundedFull: true,
							disabled: index === 0
						}}
					/>
				</label>
				<label
					class="carousel__control carousel__control--forward ml-1 z-1 cursor-pointer"
					for="carousel-activator-{index + 1}"
					class:cursor-not-allowed={index === photosUrls.length - 1}
				>
					<ButtonBoxPrimary
						props={{
							iconLeft: 'arrow_right',
							size: 'small',
							classNames: 'pointer-events-none',
							roundedFull: true,
							disabled: index === photosUrls.length - 1
						}}
					/>
				</label>
			</div>
		{/each}

		<div class="carousel__screen">
			<div class="carousel__track">
				{#each photosUrls as item, index}
					<div class="carousel__item relative">
						{#if index > 0}
							<div class="carousel__item-title">
								<div>{item.title}</div>
							</div>
						{/if}
						<div
							class="w-full {idVideoEmbed && typeVideoEmbed && index === 0 ? '' : 'aspect-video'}"
						>
							{#if idVideoEmbed && typeVideoEmbed && index === 0}
								<AdaptiveVideo
									src={item.url}
									iframeTitle={item.title}
									ratio="aspect-video"
									iframe={true}
								/>
							{:else}
								<AdaptiveImage
									src={item.url}
									alt={item.title}
									classNames="w-full h-full object-cover"
								/>
							{/if}
						</div>
					</div>
				{/each}
			</div>
		</div>
	</div>
</div>

<style lang="postcss">
	.carousel {
		@apply w-full relative flex justify-center items-center pb-6;
	}

	.carousel__activator {
		@apply hidden;
	}

	.carousel__controls {
		@apply hidden items-center absolute bottom-0 right-0;
	}

	.carousel__screen {
		@apply w-full overflow-hidden;
	}

	.carousel__track {
		@apply transition-all duration-300 whitespace-nowrap space-x-3 lg:space-x-0;
		font-size: 0;
		-webkit-overflow-scrolling: touch;
	}

	.carousel__item {
		@apply inline-flex align-top whitespace-normal w-9/12 lg:w-full;
	}

	@media screen and (max-width: 1023px) {
		.carousel__activator:nth-of-type(n):checked ~ .carousel__controls:nth-of-type(n) {
			@apply hidden;
		}
		.carousel__activator:nth-of-type(n):checked ~ .carousel__screen .carousel__track {
			@apply transform-none;
		}
		.carousel__track {
			@apply overflow-x-auto w-auto;
		}
	}

	.carousel__item-title {
		@apply absolute bottom-0 left-0 right-0 px-3 py-2 bg-gradient-to-b from-transparent to-secondary text-white z-1 text-sm min-h-[30px] lg:min-h-[60px] flex items-center;
	}
</style>
